// extracted by mini-css-extract-plugin
module.exports = {"socialInteractionContainer":"ReflectionSocialInteractions_socialInteractionContainer__M8M7_","container":"ReflectionSocialInteractions_container__OH3l4"};